import Skeleton from "react-loading-skeleton";
import { REACT_APP_GERS_API_URL } from "shared/config";
import { useRecommendedPanels } from "shared/api/hooks/useStandardProductCategories";

export const StandardProductRecommendations = () => {
  const { recommendedPanels, panelsLoading } = useRecommendedPanels();

  if (panelsLoading) {
    return (
      <div className="gg-col-span-12 lg:gg-col-span-8">
        <Skeleton className="gg-h-[500px] gg-w-full" />
      </div>
    );
  }

  if (!recommendedPanels || recommendedPanels?.length < 2) {
    return null;
  }

  return (
    <div className="gg-col-span-12 gg-h-[500px] gg-w-full lg:gg-col-span-8">
      <h4 className="gg-text-xl gg-font-bold gg-text-dark-blue lg:gg-text-2xl">
        Browse our additional panels
      </h4>
      <div className="gg-mt-5 gg-grid gg-gap-y-5 xl:gg-w-[75%]">
        {recommendedPanels.map((item, idx) => (
          <a
            href="/producten?type=acoustic_panel"
            rel="noferrer"
            target="_blank"
            className="gg-flex gg-h-[140px] gg-w-full gg-cursor-pointer gg-items-center gg-border gg-border-gray-200 gg-bg-gray-50 gg-pl-5 hover:gg-bg-gray-100"
            key={item.id || idx}
          >
            <img
              className="!gg-h-[100px] !gg-w-[140px] gg-bg-gray-200 gg-bg-cover gg-object-center gg-shadow-sm"
              src={`${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${item.thumbnailId}`}
              alt={item.mainImageAltText}
            />
            <div className="gg-flex gg-w-full gg-flex-col gg-justify-between gg-p-2.5 lg:gg-p-5">
              <div>
                <p className="gg-font-semibold gg-text-dark-blue/90 sm:gg-text-lg">
                  {item.name}
                </p>
                <p className="gg-mt-2.5 gg-text-sm gg-font-normal gg-text-dark-blue/70">
                  {item.description}
                </p>
              </div>

              <div className="gg-justify-end gg-self-end gg-text-dark-blue">
                {"€" + item.price.toFixed(2)}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
